import { initialState } from "./index";
import { createSelector } from "@reduxjs/toolkit";

const selectUsersState = (state) => state.creatorUsers || initialState;

export const getCreatorUsersInfo = createSelector(
  [selectUsersState],
  (usersState) => usersState.creatorUsersInfo
);

export const getCreatorUserDetails = createSelector(
  [selectUsersState],
  (usersState) => usersState.creatorUserDetails
);

export const getUpdateCreatorInfo = createSelector(
  [selectUsersState],
  (usersState) => usersState.updateCreatorInfo
);

export const getBrandFollowers = createSelector(
  [selectUsersState],
  (usersState) => usersState.brandFollowers
);

export const getReviewAction = createSelector(
  [selectUsersState],
  (usersState) => usersState.reviewAction
);

export const getRestrictCreatorUser = createSelector(
  [selectUsersState],
  (usersState) => usersState.restrictCreatorUser
);
